var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: {
        width: "auto",
        title: "Mass Transfer",
        visible: _vm.dialogVisible,
        scrollbar: false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        opened: _vm.onOpened,
        closed: _vm.onClosed,
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            model: _vm.form,
            rules: _vm.formRules,
            "label-position": "right",
            "label-width": "100px",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { prop: "type", label: "Select Type" } },
            [
              _c(
                "el-select",
                {
                  attrs: { filterable: "", placeholder: "Please select Type" },
                  on: { change: _vm.changeType },
                  model: {
                    value: _vm.form.type,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "type", $$v)
                    },
                    expression: "form.type",
                  },
                },
                [
                  _c("el-option", {
                    attrs: {
                      label: "vCE",
                      value: "vCE",
                      disabled: _vm.isDisabledvCE,
                    },
                  }),
                  _c("el-option", {
                    attrs: {
                      label: "SE",
                      value: "SE",
                      disabled: _vm.isDisabledSECE,
                    },
                  }),
                  _c("el-option", {
                    attrs: {
                      label: "CE",
                      value: "CE",
                      disabled: _vm.isDisabledSECE,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { prop: "userId", label: "Select User" } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    filterable: "",
                    placeholder: "Please select User",
                    loading: _vm.loading,
                  },
                  model: {
                    value: _vm.form.userId,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "userId", $$v)
                    },
                    expression: "form.userId",
                  },
                },
                _vm._l(_vm.mlList, function (item, i) {
                  return _c("el-option", {
                    key: i,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "actions", attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.saving },
              on: { click: _vm.onConfirm },
            },
            [_vm._v(" " + _vm._s(_vm.saving ? "Saving" : "Save") + " ")]
          ),
          _c("el-button", { on: { click: _vm.onClosed } }, [_vm._v("Cancel")]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }